import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'quote',
  standalone: false,
})
export class QuotePipe implements PipeTransform {
  constructor() {}

  private quote = (value: string) => '“' + value + '”';

  // TODO - apply this after strict templates
  // transform(value: string | null | undefined): string | null | undefined;
  // transform(value: string[] | null | undefined): string[] | null | undefined;
  // transform<T>(value: T | null | undefined, property: keyof T): string | null | undefined;
  // transform<T>(value: T[] | null | undefined, property: keyof T): string[] | null | undefined;
  transform(value: string[] | string | null | undefined): any | null | undefined;
  transform<T>(value: T[] | T | null | undefined, property: keyof T): any | null | undefined;
  transform<T>(
    value: T[] | T | null | undefined,
    property?: keyof T,
  ): string[] | string | null | undefined {
    if (value == null) {
      return null;
    }

    if (property != null) {
      if (Array.isArray(value)) {
        return value.map(x => this.quote(x[property] as unknown as string));
      }

      return this.quote(value[property] as unknown as string);
    }

    if (typeof value === 'string') {
      return this.quote(value);
    }

    return (value as unknown[] as string[]).map(this.quote);
  }
}
